function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rgba } from 'polished';
import { shade, tint, themify } from '../../styles/mixins';
const StyledColor = styled.span.withConfig({
  displayName: "Color__StyledColor",
  componentId: "sc-15g4zh0-0"
})(["color:", ";"], x => x.color).withComponent((_ref) => {
  let {
    color
  } = _ref,
      domProps = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React.createElement("span", domProps);
});
export const Color = (_ref2) => {
  let {
    c,
    children,
    o,
    s,
    t
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["c", "children", "o", "s", "t"]);

  const themifiedColor = o ? rgba(themify(c), o) : themify(c);
  let correctedColor;

  switch (true) {
    case c && typeof s === 'number':
      correctedColor = shade(s, themifiedColor);
      break;

    case c && typeof t === 'number':
      correctedColor = tint(t, themifiedColor);
      break;

    default:
      correctedColor = themifiedColor;
  }

  return /*#__PURE__*/React.createElement(StyledColor, _extends({
    color: correctedColor
  }, props), children);
};
export const Green = (_ref3) => {
  let {
    children
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "green"
  }, props), children);
};
export const Gray = (_ref4) => {
  let {
    children
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "gray"
  }, props), children);
};
export const Gold = (_ref5) => {
  let {
    children
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "gold"
  }, props), children);
};
export const Yellow = (_ref6) => {
  let {
    children
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "yellow"
  }, props), children);
};
export const Orange = (_ref7) => {
  let {
    children
  } = _ref7,
      props = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "orange"
  }, props), children);
};
export const Red = (_ref8) => {
  let {
    children
  } = _ref8,
      props = _objectWithoutProperties(_ref8, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "red"
  }, props), children);
};
export const Blue = (_ref9) => {
  let {
    children
  } = _ref9,
      props = _objectWithoutProperties(_ref9, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "blue"
  }, props), children);
};
export const Purple = (_ref10) => {
  let {
    children
  } = _ref10,
      props = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Color, _extends({
    c: "purple"
  }, props), children);
};
Color.propTypes = {
  children: PropTypes.node.isRequired,

  /** Color */
  c: PropTypes.string.isRequired,

  /** Amount to shade (stick to 0.7 - 1) */
  s: PropTypes.number,

  /** Amount to tint (stick to 0.7 - 1) */
  t: PropTypes.number,

  /** Opacity */
  o: PropTypes.number
};